<div
  [@inOutAnimation]
  *ngIf="type == animatedLoaderType.ai_loader"
  class="loader"
>
  <span class="loader__inner"></span>
  <span class="loader__inner"></span>
</div>

<svg
  [@inOutAnimation]
  *ngIf="type == animatedLoaderType.pencel"
  xmlns="http://www.w3.org/2000/svg"
  height="200px"
  width="200px"
  viewBox="0 0 200 200"
  class="pencil"
>
  <defs>
    <clipPath id="pencil-eraser">
      <rect height="30" width="30" ry="5" rx="5"></rect>
    </clipPath>
  </defs>
  <circle
    transform="rotate(-113,100,100)"
    stroke-linecap="round"
    stroke-dashoffset="439.82"
    stroke-dasharray="439.82 439.82"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    r="70"
    class="pencil__stroke"
  ></circle>
  <g transform="translate(100,100)" class="pencil__rotate">
    <g fill="none">
      <circle
        transform="rotate(-90)"
        stroke-dashoffset="402"
        stroke-dasharray="402.12 402.12"
        stroke-width="30"
        stroke="hsl(223,90%,50%)"
        r="64"
        class="pencil__body1"
      ></circle>
      <circle
        transform="rotate(-90)"
        stroke-dashoffset="465"
        stroke-dasharray="464.96 464.96"
        stroke-width="10"
        stroke="hsl(223,90%,60%)"
        r="74"
        class="pencil__body2"
      ></circle>
      <circle
        transform="rotate(-90)"
        stroke-dashoffset="339"
        stroke-dasharray="339.29 339.29"
        stroke-width="10"
        stroke="hsl(223,90%,40%)"
        r="54"
        class="pencil__body3"
      ></circle>
    </g>
    <g transform="rotate(-90) translate(49,0)" class="pencil__eraser">
      <g class="pencil__eraser-skew">
        <rect
          height="30"
          width="30"
          ry="5"
          rx="5"
          fill="hsl(223,90%,70%)"
        ></rect>
        <rect
          clip-path="url(#pencil-eraser)"
          height="30"
          width="5"
          fill="hsl(223,90%,60%)"
        ></rect>
        <rect height="20" width="30" fill="hsl(223,10%,90%)"></rect>
        <rect height="20" width="15" fill="hsl(223,10%,70%)"></rect>
        <rect height="20" width="5" fill="hsl(223,10%,80%)"></rect>
        <rect height="2" width="30" y="6" fill="hsla(223,10%,10%,0.2)"></rect>
        <rect height="2" width="30" y="13" fill="hsla(223,10%,10%,0.2)"></rect>
      </g>
    </g>
    <g transform="rotate(-90) translate(49,-30)" class="pencil__point">
      <polygon points="15 0,30 30,0 30" fill="hsl(33,90%,70%)"></polygon>
      <polygon points="15 0,6 30,0 30" fill="hsl(33,90%,50%)"></polygon>
      <polygon points="15 0,20 10,10 10" fill="hsl(223,10%,10%)"></polygon>
    </g>
  </g>
</svg>

<svg
  [@inOutAnimation]
  *ngIf="type == animatedLoaderType.learmo_loader"
  class="pl"
  viewBox="0 0 128 128"
  width="128px"
  height="128px"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <linearGradient id="pl-grad" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="hsl(193,90%,55%)"></stop>
      <stop offset="100%" stop-color="hsl(223,90%,55%)"></stop>
    </linearGradient>
  </defs>
  <circle
    class="pl__ring"
    r="56"
    cx="64"
    cy="64"
    fill="none"
    stroke="hsla(0,10%,10%,0.1)"
    stroke-width="16"
    stroke-linecap="round"
  ></circle>
  <path
    class="pl__worm"
    d="M92,15.492S78.194,4.967,66.743,16.887c-17.231,17.938-28.26,96.974-28.26,96.974L119.85,59.892l-99-31.588,57.528,89.832L97.8,19.349,13.636,88.51l89.012,16.015S81.908,38.332,66.1,22.337C50.114,6.156,36,15.492,36,15.492a56,56,0,1,0,56,0Z"
    fill="none"
    stroke="url(#pl-grad)"
    stroke-width="16"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-dasharray="44 1111"
    stroke-dashoffset="10"
  ></path>
</svg>
<!-- <button (click)="invertAnimation()">Invert</button> -->
